// import React, { useState } from "react";
import { Sidebar } from "primereact/sidebar";
import styles from "./index.module.scss";
import MobilePriceLayout from "../mobile-price-layout";
import MobileBidDetails from "../mobile-bid-details";
import MobilePropertyFeatures from "../mobile-property-features";
import { numberWithCommas, phoneMask } from "../../../../utils/const";
import MobilePropertyDocumnets from "../mobile-property-documents";
import MobileRelatedProperties from "../mobile-related-properties";
import { useParams, useSearchParams } from "react-router-dom";
import { isMobileBidsData } from "../../../../utils/utils";
import ButtonC from "../../button";
import MobilePropertyDescription from "../mobile-property-description";
import MobileAgentInfo from "../mobile-agent-info";
import { StatusColorObj } from "../../../property-list/property-list-grid/property-list-grid.interface";
import AdditionalMobileInformation from "../additional-information";
import { ContactAgents } from "../../../investor/amplitude";
import { useToast } from "../../toast/toast";
import { useContactAgent } from "../../../../hooks/react-query/investor/useContactAgent";
import useContextHook from "../../../../hooks/context/useContext";
import { useState } from "react";
import moment from "moment";
import PriceDropTag from "../../pricedrop-tag";
// import PropertyDesc from "../../../../stories/property-detail/property-description";

interface PropType {
  visibleBottom: boolean;
  setVisibleBottom: (visible: boolean) => void;
  objPropertyDetails: any;
  setVisiblePlaceBid: (visible: boolean) => void;
  Status: StatusColorObj;
  type: string;
}
export default function MobileDetailsSidebar({
  visibleBottom,
  setVisiblePlaceBid,
  setVisibleBottom,
  objPropertyDetails,
  Status,
  type
}: PropType) {
  const { propertyId } = useParams();
  const mobileBidsData = isMobileBidsData(objPropertyDetails);
  const [showThankYou, setShowThankYou] = useState(false);
  const [searchParams] = useSearchParams(window.location.search);
  const { mobileNumber } = useContextHook();
  const cid = searchParams.get("cid") || "";
  const eq = searchParams.get("eq") || "";
  const { showError }: any = useToast();
  const ContactAgentMutation = useContactAgent(
    (data: any) => {
      setShowThankYou(true);
      ContactAgents({
        propertyId: objPropertyDetails?.propertyId,
        propertySFID: objPropertyDetails?.propertySFID,
        shareId: propertyId || "",
        pubPropertySFID: objPropertyDetails?.pubPropertySFID,
        opportunitySFID: objPropertyDetails?.opportunitySFID,
        linkCId: cid,
        linkEmailId: eq,
        ...(mobileNumber && { mobileNumber: mobileNumber })
      });
    },
    (error) => {
      showError("error", error.response.data.message || "something went wrong");
    }
  );
  return (
    <Sidebar
      visible={visibleBottom}
      position="bottom"
      onHide={() => setVisibleBottom(false)}
      className={styles.mobileSidebar}
      header={
        <img
          src="/images/downarrow.svg"
          alt=""
          onClick={() => setVisibleBottom(false)}
        />
      }
    >
      <div
        className={`${styles.scrollableContent} ${
          objPropertyDetails?.status === "Sold" ? styles.soldHeight : ""
        }`}
      >
        <MobilePriceLayout
          type={type}
          priceDrop={objPropertyDetails?.priceDrop}
          priceDropDate={objPropertyDetails?.priceDropDate}
          Status={Status}
          objStatus={objPropertyDetails?.status}
          amount={objPropertyDetails?.askingPrice}
          currencyCode="USD"
          locale="en-US"
          house={objPropertyDetails?.objPriceLayout?.house}
          sqft={numberWithCommas(objPropertyDetails?.sqft || 0)}
          lotSizeSqFt={numberWithCommas(objPropertyDetails?.lotSizeSqFt || 0)}
          lotSizeSqFtText={"Lot Size"}
          bed={objPropertyDetails?.beds || objPropertyDetails?.bedRooms}
          bath={objPropertyDetails?.baths || objPropertyDetails?.totalBath}
          car={objPropertyDetails?.objPriceLayout?.car}
          sqftText="Sq.Ft"
          address={objPropertyDetails?.address}
        />
        <MobilePropertyDescription
          title={"Property Description"}
          propertyDetails={objPropertyDetails?.description}
          viewMoreWords={250}
          type={type}
        />
        {type !== "investor" && (
          <AdditionalMobileInformation
            objPropertyDetails={objPropertyDetails}
            type={type}
          />
        )}
        {objPropertyDetails?.internalNotes && (
          <MobilePropertyDescription
            Notes={true}
            title={"Internal Notes"}
            propertyDetails={objPropertyDetails?.internalNotes}
            viewMoreWords={500}
          />
        )}
        {objPropertyDetails?.docs?.length > 0 && (
          <MobilePropertyDocumnets
            type={type}
            title={"Documnets"}
            objPropertyDetails={objPropertyDetails}
            minShowData={5}
            maxShowData={0}
          />
        )}
        {type !== "investor" && mobileBidsData && (
          <MobileBidDetails
            title={"Bid Details"}
            dateTimeTitle={"Showing Date and Time"}
            dateTime={objPropertyDetails?.showingDateAndTime}
            company={"BS Escrow Company"}
            company_subtitle={objPropertyDetails?.bsEscrowCompany}
            offersDueTitle={"Offer Due Date and Time"}
            offersDateTime={objPropertyDetails?.offerDueDateAndTime}
            closeTitle={"Close Date"}
            closeDate={objPropertyDetails?.closeDate}
            depositTitle={"BS Deposit"}
            amount={objPropertyDetails?.bsDeposit}
            currencyCode="USD"
            locale="en-US"
            sales={"Sales Instructions"}
            salesInstruction={objPropertyDetails?.salesInstruction}
          />
        )}
        <MobilePropertyFeatures
          title={"Property Features"}
          objPropertyDetails={objPropertyDetails}
          minShowData={5}
          maxShowData={7}
          type={type}
        />
        {type !== "investor" && (
          <div className={styles.agentBox}>
            {objPropertyDetails?.acquisitionAgent1?.name && (
              <MobileAgentInfo
                profileImg={
                  objPropertyDetails?.acquisitionAgent1?.mediumPhotoUrl
                }
                title={"Acquisition Agent"}
                name={`${
                  objPropertyDetails?.acquisitionAgent1?.name?.split(" ")[0] ??
                  ""
                } ${
                  objPropertyDetails?.acquisitionAgent1?.name?.split(" ")[1] ??
                  ""
                }`}
                lastName={
                  objPropertyDetails?.acquisitionAgent1?.name?.split(" ")[1] ??
                  ""
                }
                email={objPropertyDetails?.acquisitionAgent1Email ?? ""}
                phone={
                  phoneMask(
                    Number(objPropertyDetails?.acquisitionAgent1Phone)
                  ) ?? null
                }
              />
            )}

            {/* {loading ? (
                <PlaceOfferSkeleton />
              ) : (
                <PlaceOffer
                  price={objPriceLayout.amount}
                  address={objPriceLayout.address}
                  propertyId={propertyId}
                  // viewProperty={state?.state?.propertyDetails}
                />
              )} */}
            <div className={styles.relatedProperty}>
              <MobileRelatedProperties
                propertyId={`${propertyId}`}
                title={"Related Properties"}
                currencyCode={"USD"}
                locale={"en-US"}
              />
            </div>
          </div>
        )}
      </div>
      {type !== "investor" ? (
        //  &&
        //   (objPropertyDetails?.offerDueDateAndTime === null ||
        //     moment(objPropertyDetails?.offerDueDateAndTime).isAfter(
        //       moment().utc()
        //     ))
        <div className={styles.footer}>
          <ButtonC
            disabled={objPropertyDetails?.status === "Sold"}
            type="button"
            label="Place Bid"
            size="large"
            tabIndex={29}
            className={styles.btn}
            onClick={() => setVisiblePlaceBid(true)}
          />
        </div>
      ) : (
        <div className={styles.footer}>
          {showThankYou ? (
            <div className={styles.thankYouBox}>
              <span className={styles.bellIcon}>
                <img src="/images/bell.svg" alt="" />
              </span>
              <span className={styles.thankYouText}>
                Thanks for reaching out! One of our agents will be in touch soon
                to share more details and help you explore this opportunity
                further.
              </span>
            </div>
          ) : (
            <div className={styles.connectWithAgent}>
              <div className={styles.message}>
                Want to Explore This Investment?
              </div>
              {!ContactAgentMutation?.isPending ? (
                <img
                  src="/images/yes-connect-agent.svg"
                  alt=""
                  onClick={() => {
                    ContactAgentMutation.mutate({
                      pubPropertyId: objPropertyDetails.id,
                      date: moment().format("MM-DD-YYYY hh:mm:ss A")
                    });
                  }}
                />
              ) : (
                <img
                  src="/images/yes-connect-agent.svg"
                  alt=""
                  style={{ opacity: 0.7 }}
                />
              )}
            </div>
          )}
        </div>
      )}
    </Sidebar>
  );
}
